module.exports = __webpack_public_path__ + "static/media/right-direction-img.aa8a8e9e.svg";